import { render, staticRenderFns } from "./CmsIndexDetails.vue?vue&type=template&id=4ed73560&scoped=true"
import script from "./CmsIndexDetails.vue?vue&type=script&lang=ts"
export * from "./CmsIndexDetails.vue?vue&type=script&lang=ts"
import style0 from "./CmsIndexDetails.vue?vue&type=style&index=0&id=4ed73560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed73560",
  null
  
)

export default component.exports